import { render, staticRenderFns } from "./Lab.vue?vue&type=template&id=fd7b1310&scoped=true&"
import script from "./Lab.vue?vue&type=script&lang=js&"
export * from "./Lab.vue?vue&type=script&lang=js&"
import style0 from "./Lab.vue?vue&type=style&index=0&id=fd7b1310&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7b1310",
  null
  
)

export default component.exports